export const STORE_HEADQUARTERS = 'headquarters';
export const HQ_SET_FILTERS = 'setFilters';
export const HQ_SET_OPTIONS = 'setOptions';

export const HQ_FETCH_DATA = 'fetchData';
export const HQ_FETCH_HOLIDAYS = 'fetchHolidays';
export const HQ_FETCH_CHAIN_STATS_DATA = 'fetchChainStatsData';
export const HQ_FETCH_CHAINS_DATA = 'fetchChainsData';
export const HQ_UPDATE_CHAINS_DATA = 'updateChainsData';

export const STORE_HQ_REG_HOTELS = 'hqRegisteredHotels';
export const STORE_HQ_REG_GROUPS = 'hqRegisteredGroups';
export const HQ_SELECT_FIRST_REGISTERED_GROUP = 'selectFirstRegisteredGroup';
export const HQ_UPDATE_REGISTERED_DATA = 'updateRegisteredHotelsData';
export const HQ_UPDATE_SCRAPPING_DATA = 'updateScrappingData';
export const HQ_UPDATE_USER_SELECTED_OTA_DATA = 'updateUserSelectedOtas';
export const HQ_UPDATE_SELECTED_HOTELS = 'updateSelectedHotels';
export const HQ_UPDATE_SELECTED_CHAINS = 'updateSelectedChains';

export const STORE_HQ_SCRAPPING = 'hqScrapping';
export const HQ_START_IMPORT = 'startScrapping';
export const HQ_STOP_IMPORT = 'stopScrapping';
export const HQ_UPDATE_IMPORT_DATA = 'updateScrappingData';

export const STORE_HQ_REG_DOWNLOAD = 'hqRegDownload';
export const STORE_HQ_CHAIN_DOWNLOAD = 'hqChainDownload';
export const HQ_DOWNLOAD_REGISTERED = 'downloadRegisteredPrices';
export const HQ_DOWNLOAD_DETAILED = 'downloadDetailedPrices';
export const HQ_DOWNLOAD_INVENTORY = 'downloadInventoryData';
export const HQ_INIT_DOWNLOAD_NAMESPACE = 'initDownloadNamespace';

export const STORE_HQ_CHAINS = 'hqChainHotels';
export const STORE_HQ_CHAINS_GROUP = 'hqChainHotelsGroup';
export const HQ_SELECT_FIRST_CHAIN_GROUP = 'selectFirstChainGroup';

export const HQ_DELETE_GROUP = 'hqDeleteGroup';
export const HQ_ADD_GROUP = 'hqAddGroup';
export const HQ_EDIT_GROUP = 'hqEditGroup';
export const HQ_INIT_GROUPS = 'hqInitGroups';

export const HQ_CHAIN_LIMITATION = 10;
export const HQ_HOTEL_LIMITATION = 10;
export const HQ_GROUPNAME_LIMITATION = 25;

export const PERCENT_TAX = 8;
export const PERCENT_NEW_TAX = 10;
export const DATE_NEW_TAX = '2019-10-01';
